import { useAuthStore } from '../stores/useAuthStore';

/**
 * Hook para interactuar con el estado global de autenticación.
 * Actúa como un selector y despachador de acciones para `authStore`.
 * Reemplaza la necesidad de `AuthContext` y `AuthProvider`.
 */
export const useAuth = () => {
  const user = useAuthStore((state) => state.user);
  const token = useAuthStore((state) => state.token);
  const isLoading = useAuthStore((state) => state.isLoading);
  const login = useAuthStore((state) => state.login);
  const logout = useAuthStore((state) => state.logout);
  const setUser = useAuthStore((state) => state.setUser);

  // Devolvemos una interfaz compatible con la que usaban los componentes antiguos.
  // Esto minimiza la necesidad de refactorizar todos los componentes que usan `useAuth`.
  return {
    currentUser: user,
    token,
    isLoading,
    isLoggedIn: !!user,
    login,
    logout,
    setCurrentUser: setUser, // Mapeamos `setUser` a `setCurrentUser` por compatibilidad.
  };
};

// El AuthProvider ya no es necesario. El `authStore` con su middleware `persist`
// se encarga de toda la lógica que antes estaba en AuthProvider y AuthContext.
// El siguiente paso será eliminar el AuthProvider de `AppProviders.jsx` y
// el archivo `AuthContext.jsx`.
